import { render, staticRenderFns } from "./firstDraft .vue?vue&type=template&id=02c85edb&scoped=true&"
import script from "./firstDraft .vue?vue&type=script&lang=js&"
export * from "./firstDraft .vue?vue&type=script&lang=js&"
import style0 from "./firstDraft .vue?vue&type=style&index=0&id=02c85edb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c85edb",
  null
  
)

export default component.exports